/** @format */

import PlatformResellerInterface from '../interfaces/platform/PlatformResellerInterface';

export class PlatformResellerHelper {
    static hasParentReseller = (platformReseller: PlatformResellerInterface): boolean => {
        if (platformReseller.parentResellerId) {
            return true;
        } else {
            return false;
        }
    };

    static hasChildrenResellers = (platformResellerId: number, allResellers: Array<PlatformResellerInterface> | null): boolean => {
        let hasChildrens = false;
        if (allResellers) {
            allResellers.forEach((el: PlatformResellerInterface) => {
                if (el.parentResellerId === platformResellerId) {
                    hasChildrens = true;
                }
            });
        }

        return hasChildrens;
    };
}
